export class Selected<T> {
	constructor(fnValue: (T) => any, fnLabel: (T) => string, public items: T[] = [], public sorted:boolean=true) {
		this.value = fnValue;
		this.label = fnLabel;
	}

	value: (T) => any;
	label: (T) => string;

	select(item: T) {
		if (!this.items.some(x => this.value(x) == this.value(item))) {
			this.items.push(item);
			if (this.sorted)
				this.items.sort((a, b) => this.label(a) < this.label(b) ? -1 : this.label(a) > this.label(b) ? 1 : 0);
		}
	}

	unselect(item: T) {
		this.items = this.items.filter(x => x != item)
	}

	clear() {
		this.items = [];
	}

	get isEmpty(): boolean {
		return this.items.length === 0;
	}
}
